import { MAILING_SAME_AS_ABOVE_FIELD_KEY, PROPERTY_LOCATION_PREFIX, MAILING_ADDRESS_PREFIX } from '../constants';

export function syncMailingAddress(formValues) {
  if (!formValues[MAILING_SAME_AS_ABOVE_FIELD_KEY]) return formValues;

  const payload = { ...formValues };
  Object.keys(formValues).forEach((key) => {
    if (key.startsWith(PROPERTY_LOCATION_PREFIX)) {
      const mailingKey = key.replace(PROPERTY_LOCATION_PREFIX, MAILING_ADDRESS_PREFIX);
      payload[mailingKey] = formValues[key];
    }
  });

  return payload;
}
